export const USER_FILTER_LIST = [
  {
    label: 'Niels Schrijver',
    value: 33,
  },
  {
    label: 'Joris Koerhuis',
    value: 25,
  },
  {
    label: 'Richard  Holterman',
    value: 38,
  },
  {
    label: 'Jan Wolf',
    value: 20,
  },
  {
    label: 'Teun Fransen',
    value: 49,
  },
  {
    label: 'Marcel Post',
    value: 28,
  },
  {
    label: 'Gijs in de Wal',
    value: 16,
  },
  {
    label: 'Nick Volkov',
    value: 32,
  },
  {
    label: 'Thimas van Zantwijk',
    value: 51,
  },
  {
    label: 'Harrie in de Wal',
    value: 17,
  },
  {
    label: 'Kai Schelhaas',
    value: 26,
  },
  {
    label: 'Daley Schelhaas',
    value: 9,
  },
  {
    label: 'Michiel Bosman',
    value: 30,
  },
  {
    label: 'Gernand van Norden',
    value: 15,
  },
  {
    label: 'Sander Piepers',
    value: 44,
  },
  {
    label: 'Rachel Klunder',
    value: 36,
  },
];

export const VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE = [
  'economic_prize',
  'financial_purchase_price_marge_bpm',
  'financial_purchase_price_marge_excl_bpm',
  'rest_bpm',
  'taxiVerleden',
  'financial_bpm_gross',
];

export const VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW = [
  'financial_purchase_price_incl_vat_bpm',
  'economic_prize',
  'rest_bpm',
  'taxiVerleden',
  'financial_purchase_price_incl_vat_excl_bpm',
  'financial_purchase_price_incl_bpm_excl_btw',
  'vat_percentage',
  'vat_amount',
  'financial_purchase_price_excl_vat_excl_bpm',
  'financial_bpm_gross',
];

export const VEHICLE_DETAILS_VEHICLE_DATA_CARD = [
  'vin',
  'regplate',
  'mileage',
  'new_from_factory',
  'import',
  'ex_rental',
  'date_first_allowance',
  'fuel_type',
  'transmission_type',
  'body_type',
  'base_color',
  'secondary_color',
  'battery_capacity',
  // 'stadagen',
  'power',
  'power_axle',
  'date_expected',
  'nedcCo2Emission',
  'wltpCo2Emission',
  'euro_class',
];

export const VEHICLE_DETAILS_SALESCARD = [
  'financial_price_b2c',
  'financial_price_b2b_incl_vat_btpm',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  //'outgoing_rest_bpm',
  'rest_bpm_export',
  'catalogprice_incl_options',
  'delivery_costs',
  'sell_with_license_plate',
  'sell_without_license_plate',
  'fix_damages',
  'dont_fix_damages',
  'fix_damages_details',
];

export const EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2 = [
  'status',
  'transmission_type',
  'fuel_type',
  'power',
  'battery_capacity',
  'vehicle_purpose',
  'tax_type',
  // 'rest_bpm',
  // 'financial_bpm_gross',
  'financial_price_b2c',
  'nedcCo2Emission',
  'wltpCo2Emission',
  'financial_price_b2b_incl_vat_btpm',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  'action_ws1_1_labels_done',
  'link_to_inspection_report',
  'economic_prize',
];

export const BUYERS_OPTIONS = [
  {
    label: 'Niels Schrijver',
    value: 33,
  },
  {
    label: 'Joris Koerhuis',
    value: 25,
  },
  {
    label: 'Richard  Holterman',
    value: 38,
  },
  {
    label: 'Jan Wolf',
    value: 20,
  },
  {
    label: 'Teun Fransen',
    value: 49,
  },
  {
    label: 'Marcel Post',
    value: 28,
  },
  {
    label: 'Gijs in de Wal',
    value: 16,
  },
  {
    label: 'Nick Volkov',
    value: 32,
  },
  {
    label: 'Thimas van Zantwijk',
    value: 51,
  },
  {
    label: 'Harrie in de Wal',
    value: 17,
  },
  {
    label: 'Kai Schelhaas',
    value: 26,
  },
  {
    label: 'Daley Schelhaas',
    value: 9,
  },
  {
    label: 'Michiel Bosman',
    value: 30,
  },
  {
    label: 'Gernand van Norden',
    value: 15,
  },
  {
    label: 'Sander Piepers',
    value: 44,
  },
  {
    label: 'Rachel Klunder',
    value: 36,
  },
];
